module.exports = __webpack_public_path__ + "static/media/hr1.8426e669.avif";